<template>
  <section class="has-listing-table">
    <div class="level no-margin">
      <div class="level-left">
        <div class="level-item-horizontal">
          <h1 class="is-title-header">Survey Packaging List</h1>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li><a @click.prevent="startSurvey">Start New Survey</a></li>
          </ul>
        </div>
        <!-- <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li><a @click.prevent="copySurvey">Copy Survey</a></li>
          </ul>
        </div> -->
      </div>
    </div>
    <div class="enable-select-text">
      <circul8-table
        ref="circul8Table"
        :records="data"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="false"
        :maxTextLength="'24'"
        :isLoading="isDataLoading"
        :backendSortingEnabled="true"
        @clickEdit="clickEditProduct"
        @clickView="clickViewProduct"
        @backendSort="sortData"
        :showRemoveButton="false"
        :showEditButton="true"
        :showCopyButton="true"
        :routeNext="false"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        :saveDataFields="true"
        :tableName="tblName"
        @copy="copyAction"
      />
    </div>
    <div class="records-displayed" v-if="totalRecords > 0">
      <span v-if="currentPage * 50 + 50 < totalRecords"
        >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
        {{
          currentPage > 0
            ? nextPageCursor
              ? currentPage * 50 - 50 + data.length
              : totalRecords
            : data.length
        }}
        records out of {{ totalRecords }} records</span
      >
      <div v-else>
        <span v-if="currentPage == 0">
          displaying 0 - {{ totalRecords }} records out of
          {{ totalRecords }} records
        </span>
        <span v-else>
          displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
          out of {{ totalRecords }} records
        </span>
      </div>
    </div>
    <copy-survey
      :is-active="isCopySurveyModal"
      :customer-id="customerId"
      @cancel="copyCancel"
    />
  </section>
</template>
<script>
import Circul8Table from "@/components/Circul8Table.vue";
import RamSurveyService from "@/services/RAMSurveyService";
import CopySurvey from "@/components/Survey/CopySurvey.vue";
import * as dayjs from "dayjs";
export default {
  name: "SurveyPackagingList",

  components: { Circul8Table, CopySurvey },
  props: {
    customerId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      tblName: "SurveyProductList",
      data: [],
      isDataLoading: false,
      isModalActive: false,
      isCopySurveyModal: false,
      action: null,
      isAdd: false,
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      columns: [
        {
          field: "packaging_item",
          label: "Packaging Item",
          searchable: true,
          searchKey: "packaging_item",
          type: "input",
          filterKey: { packaging_item: "" }
        },
        {
          field: "status",
          label: "Survey Status",
          type: "input",
          searchable: true,
          searchKey: "status",
          filterKey: { status: "" }
        },
        {
          field: "result_category",
          label: "Result Category",
          searchable: true,
          type: "input",
          searchKey: "result_category",
          filterKey: { result_category: "" }
        },
        {
          field: "created_at",
          label: "Created At",
          searchable: true,
          filterKey: { created_at: "" },
          type: "dateField"
        },
        {
          field: "created_by",
          label: "Created By",
          searchable: true,
          filterKey: { created_by: "" },
          type: "input"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      surveyService: new RamSurveyService()
    };
  },
  // watch: {
  //   customerId(val) {
  //     this.fetchSurveyPackagingData(this.query);
  //   }
  // },
  mounted() {
    this.fetchSurveyPackagingData(this.query);
  },
  methods: {
    startSurvey() {
      this.$router.push({
        name: "survey"
      });
    },
    copySurvey() {
      this.isCopySurveyModal = true;
    },
    copyCancel() {
      this.isCopySurveyModal = false;
    },
    copyAction(row) {
      this.$router.push({
        name: "survey",
        params: {
          editObject: row,
          action: "copy"
        }
      });
    },
    prepareData(rawdata) {
      const dataList = [];
      for (const report in rawdata) {
        const reportData = rawdata[report];
        reportData["actions"] = reportData["status"] == "Draft" ? true : false;
        dataList.push(reportData);
      }
      if (this.nextPageCursor == null) {
        this.data.push(...rawdata);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = rawdata;
      }
      this.isDataLoading = false;
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchSurveyPackagingData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchSurveyPackagingData(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchSurveyPackagingData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchSurveyPackagingData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchSurveyPackagingData(query = "", scrollDir) {
      this.isDataLoading = true;
      this.isLoading = true;
      // rename this getSurveyData to getSurveyProductData when the API is ready
      this.surveyService.getSurveyPackingData(this.customerId, query).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            //this.totalRecords = this.data.length + response["count"];
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.data, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.data];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"], scrollDir);
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isDataLoading = false;
          this.isLoading = false;
          this.nextData = false;
        }
      );
    },
    clickEditProduct(editObject) {
      this.$router.push({
        name: "survey",
        params: {
          editObject: editObject,
          action: "edit"
        }
      });
    },
    clickViewProduct(editObject) {
      this.$router.push({
        name: "survey",
        params: {
          editObject: editObject,
          action: "view"
        }
      });
    }
  }
};
</script>
